import type { FaqSection } from "./types";

const masterDealersSection: FaqSection = {
  id: "master-dealers",
  title: "Master Dealers",
  faqs: [
    {
      question: "What is a Master Dealer in the solar industry?",
      answer: (
        <p>
          A Master Dealer manages relationships with Sales Dealers, providing them access to financing, products, and
          installers. Enerflo simplifies deal submission, commission tracking, and installer coordination for Master
          Dealers.
        </p>
      ),
    },
    {
      question: "How does Enerflo support Master Dealer operations?",
      answer: (
        <p>
          Enerflo centralizes dealer onboarding, project submissions, finance approvals, and reporting. With Direct Pay
          Commissions, Master Dealers can protect sales reps by ensuring accurate and timely payments.
        </p>
      ),
    },
    {
      question: "Can Master Dealers onboard new Sales Dealers in Enerflo?",
      answer: (
        <p>
          Yes. Enerflo allows Master Dealers to quickly set up new dealers with custom pricing, branded proposal
          templates, and financing access.
        </p>
      ),
    },
    {
      question: "How does Enerflo improve accuracy in project submissions?",
      answer: (
        <p>
          Enerflo’s Title Checks and Smart Pulls prevent common errors before a project reaches installation, saving
          time and reducing costly delays.
        </p>
      ),
    },
    {
      question: "Can Master Dealers track performance by dealer?",
      answer: (
        <p>
          Yes. Enerflo offers reporting dashboards that allow Master Dealers to view sales performance, financing
          approval rates, and installation timelines by individual dealers.
        </p>
      ),
    },
  ],
};

export default masterDealersSection;
